"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TMS_COLORS = exports.COLORS = void 0;
exports.COLORS = {
    GRAY_1: '#DFDFDF',
    GRAY_2: '#F2F2F2',
    GRAY_5: '#959595',
    BLUE_6: '#EFF2FF',
    LAVENDER_2: '#F8F9FF',
    // COLORS DESTINY
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    ZAMP_PRIMARY: '#2546F5',
    ZAMP_SECONDARY: '#EEF1FF',
    ZAMP_TERTIARY: '#F9FAFF',
    RED_PRIMARY: '#B12424',
    RED_SECONDARY: '#D64141',
    RED_TERTIARY: '#FCE9E9',
    GREEN_PRIMARY: '#0A8458',
    GREEN_SECONDARY: '#21BF86',
    GREEN_TERTIARY: '#E9F6F2',
    ORANGE_PRIMARY: '#C06B32',
    ORANGE_SECONDARY: '#EF7A2C',
    ORANGE_TERTIARY: '#FDEDE2',
    TEXT_PRIMARY: '#181B28',
    TEXT_SECONDARY: '#60616B',
    TEXT_TERTIARY: '#A0A1A9',
    BASE_PRIMARY: '#F5F5F5',
    BASE_SECONDARY: '#FBFBFE',
    DIVIDER_GRAY: '#E2E2E2',
    // DESTINY 2.0 COLORS
    BG_BACKDROP: '#FBFBFA',
    BG_HOVER: '#F9FBFF',
    BG_HOVER_2: '#F2F4F8',
    BG_03: '#FBFBFA',
    BG_FOCUSED_STATE: '#F6EFFF',
    BG_TAB_HOVER: '#EEF8FF',
    BG_TAB_SELECTION: '#E0F0FC',
    DIVIDER_GRAY_1: '#F4F4F4',
    DIVIDER_GRAY_2: '#EDEDED',
    DIVIDER_GRAY_3: '#E6E6E6',
    DIVIDER_SAIL_1: '#F3F3ED',
    DIVIDER_SAIL_2: '#E9E9E0',
    DIVIDER_SAIL_3: '#E2E2DA',
    DIVIDER_SAIL_4: '#93937B',
    TEXT_WHITE: '#E6E6E6',
    GRAY_100: '#F4F4F4',
    GRAY_200: '#EDEDED',
    GRAY_300: '#E6E6E6',
    GRAY_400: '#C3C3C3',
    GRAY_500: '#A6A6A6',
    GRAY_600: '#6B6B6B',
    GRAY_700: '#111619',
    SUCCESS_300: '#22A356',
    SUCCESS_200: '#6FBF81',
    SUCCESS_100: '#B3E9C2',
    SUCCESS_50: '#DDFADF',
    ERROR_800: '#3E021A',
    ERROR_700: '#890D37',
    ERROR_600: '#B3093C',
    ERROR_500: '#DF1B41',
    ERROR_400: '#FC526A',
    ERROR_300: '#FE87A1',
    ERROR_200: '#FFB1CD',
    ERROR_100: '#FFE7F2',
    ERROR_50: '#FFF5FA',
    BLUE_500: '#2546F5',
    BLUE_400: '#4389F2',
    BLUE_300: '#89B5F4',
    BLUE_200: '#AFCFFE',
    BLUE_100: '#AFCFFE',
    BLUE_50: '#EBF2FC',
    GREEN_300: '#22A356',
    ORANGE_300: '#FCBD3A',
    ORANGE_500: '#ED6704',
    ORANGE_600: '#C84801',
    // DESTINY 2.0 COLORS END
};
exports.TMS_COLORS = {
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    BG_BACKDROP: '#FBFBFA',
    BG_HOVER: '#F9FBFF',
    BG_HOVER_2: '#F2F4F8',
    BG_03: '#FBFBFA',
    BG_FOCUSED_STATE: '#F6EFFF',
    BG_TAB_HOVER: '#EEF8FF',
    BG_TAB_SELECTION: '#E0F0FC',
    DIVIDER_GRAY_1: '#F4F4F4',
    DIVIDER_GRAY_2: '#EDEDED',
    DIVIDER_GRAY_3: '#E6E6E6',
    DIVIDER_SAIL_1: '#F3F3ED',
    DIVIDER_SAIL_2: '#E9E9E0',
    DIVIDER_SAIL_3: '#E2E2DA',
    DIVIDER_SAIL_4: '#93937B',
    TEXT_WHITE: '#E6E6E6',
    GRAY_100: '#F4F4F4',
    GRAY_200: '#EDEDED',
    GRAY_300: '#E6E6E6',
    GRAY_400: '#C3C3C3',
    GRAY_500: '#A6A6A6',
    GRAY_600: '#6B6B6B',
    GRAY_700: '#111619',
    SUCCESS_300: '#22A356',
    SUCCESS_200: '#6FBF81',
    SUCCESS_100: '#B3E9C2',
    SUCCESS_50: '#DDFADF',
    ERROR_800: '#3E021A',
    ERROR_700: '#890D37',
    ERROR_600: '#B3093C',
    ERROR_500: '#DF1B41',
    ERROR_400: '#FC526A',
    ERROR_300: '#FE87A1',
    ERROR_200: '#FFB1CD',
    ERROR_100: '#FFE7F2',
    ERROR_50: '#FFF5FA',
    BLUE_500: '#2546F5',
    BLUE_400: '#4389F2',
    BLUE_300: '#89B5F4',
    BLUE_200: '#AFCFFE',
    BLUE_100: '#AFCFFE',
    BLUE_50: '#EBF2FC',
    GREEN_300: '#22A356',
    ORANGE_300: '#FCBD3A',
    ORANGE_500: '#ED6704',
    ORANGE_600: '#C84801',
};
